import Edit from "components/custom/Edit";
import {
  Create,
  Form,
  required,
  TextInput,
  useCreate,
  useGetOne,
  useNotify,
  useRedirect, useRefresh,
  useUpdate
} from "react-admin";
import { useParams } from "react-router-dom";
import useSetTabTitle from "hooks/useSetTabTitle";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { useWatch } from "react-hook-form";
import React, { useState } from "react";
import DeleteEntityModal from "components/category/DeleteEntityModal";

const ColorPickerField = () => {
  const color = useWatch({ name: "color" }) as string | undefined;

  return (
    <>
      <Typography variant="body2">Цвет</Typography>
      <TextInput
        sx={{ width: "500px" }}
        source={"color"}
        type="color"
        label={false}
        helperText={color ? `Выбран цвет: ${color}` : "Нажмите для выбора цвета"}
        validate={[required()]}
      />
    </>
  );
}

const QuestionDocumentTypePage = () => {
  const params = useParams();
  const { id } = params;
  const isEdit = id != null

  const { data: record, isLoading } = useGetOne("question-document-type", { id });

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const [create, { isPending: isCreating }] = useCreate();
  const [update, { isPending: isUpdating }] = useUpdate();

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const onSubmit = (data: any) => {
    if (isEdit) {
      update(
        `question-document-type/${id}`,
        { id: id, data: { title: data.title, color: data.color } },
        {
          onSuccess: () => {
            refresh()
            redirect('list', 'question-document-type')
            notify("Тип документа вопроса обновлен", { type: "success" });
          },
          onError: () => notify("Ошибка при типа документа вопроса", { type: "error" }),
        }
      );
    } else {
      create(
        "question-document-type",
        { data: { title: data.title, color: data.color } },
        {
          onSuccess: () => {
            refresh()
            redirect('list', 'question-document-type')
            notify("Тип документа вопроса создан", { type: "success" });
          },
          onError: () => notify("Ошибка при создании типа документа вопроса", { type: "error" }),
        }
      );
    }
  }

  useSetTabTitle(isEdit ? "Редактировать тип документа вопроса" : "Создать тип документа вопроса")

  if (isLoading) return <CircularProgress/>;

  return (
    <Box p={2}>
      <Form defaultValues={record} onSubmit={onSubmit}>
        <Stack spacing={1} alignItems={"flex-start"}>
          <Typography
            variant={"h4"}>
            {isEdit ? "Редактировать тип документа" : "Создать тип документа"}
          </Typography>
          <TextInput
            sx={{ width: "500px" }}
            source="title"
            label="Название"
            helperText={false}
            validate={[required()]}
          />
          <ColorPickerField/>
          <Stack direction="row" spacing="1">
            <Button
              type="submit"
              loading={isCreating || isUpdating}>
              {isEdit ? "Сохранить" : "Создать"}
            </Button>
            {
              isEdit && record ? (<Button onClick={() => setDeleteModalOpen(true)}>Удалить</Button>) : <></>
            }
          </Stack>
        </Stack>
      </Form>

      {
        isEdit && record ? (
          <DeleteEntityModal
            isOpen={isDeleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            onSuccess={() => redirect('list', 'question-document-type')}
            entity={record}
            entityText={{
              title: "Удалить тип документа",
              success: "Тип документа удален",
              error: "Ошибка при удалении типа документа"
            }}
            resource={'question-document-type'}
          />
        ) : <></>
      }
    </Box>
  );
}

export const QuestionDocumentTypeEdit = () => {
  return (
    <Edit>
      <QuestionDocumentTypePage/>
    </Edit>
  )
}

export const QuestionDocumentTypeCreate = () => {
  return (
    <Create title={"Создать тип для документа вопроса"}>
      <QuestionDocumentTypePage/>
    </Create>
  )
}
